import type {
  AysCodeCodingSystem,
  AysCodeHierarchyElementType,
} from './code-type.model';
import { AysCode } from './code.model';
import { AysCodes } from './code.factory';

export class AysCodeGroup extends AysCode {
  public static override fromObject(groupObj: any): AysCodeGroup {
    return new AysCodeGroup(
      groupObj.name,
      groupObj.description,
      groupObj.codingSystem,
      groupObj.hierarchyElementType,
      groupObj.shortName,
      groupObj.longName,
      groupObj.start ? AysCodes.fromObject(groupObj.start) : undefined,
      groupObj.end ? AysCodes.fromObject(groupObj.end) : undefined,
    );
  }

  constructor(
    name: string,
    description: string | undefined,
    codingSystem: AysCodeCodingSystem,
    hierarchyElementType: AysCodeHierarchyElementType,
    public shortName?: string,
    public longName?: string,
    public chapterStart?: AysCode,
    public chapterEnd?: AysCode,
  ) {
    super(name, description, codingSystem, hierarchyElementType);
  }

  override clone(): AysCodeGroup {
    return new AysCodeGroup(
      this.name,
      this.description,
      this.codingSystem,
      this.hierarchyElementType,
      this.shortName,
      this.longName,
      this.chapterStart ? this.chapterStart.clone() : undefined,
      this.chapterEnd ? this.chapterEnd.clone() : undefined,
    );
  }
}
